import app from 'app';
import ready from 'utils/ready';
import blog from './blog/main';

app.add({
  blog,
});

ready(app.mount);
